export default __webpack_public_path__ + "static/media/infos_collaborateurs.badebb4e.svg";